/**
 * Subscription Product Slide Component
 * Controls product selection in the subscription flow
 */
if (!customElements.get('subscription-product-slide')) {
  customElements.define(
    'subscription-product-slide',
    class SubscriptionProductSlide extends HTMLElement {
      constructor() {
        super();
        this.unsubscribe = [];
        this.updateSelectedVariant = this.updateSelectedVariant.bind(this);
      }

      connectedCallback() {
        // Create a resize handler for the screen width
        const handleResize = () => {
          if (window.screen.width < 769) {
            if (!this.carousel) {
              this.createCarousel();
            }
          } else {
            if (this.carousel) {
              this.destroyCarousel();
            }
          }
        };
        this.resizeHandler = window.addEventListener('resize', handleResize);
        // Run once on load as well
        handleResize();
        if (this.selectedVariant) {
          window.initialVariantDetails = this.variantDetails;

          publish('subscription-flow:selected-variant', {
            selected_variant: this.selectedVariant,
            variant_details: this.variantDetails,
          });
        }

        Utils.HeightManager.init(this, '--product-slide-content-height');
        this.setupEventListeners();
        this.setupVariantSelection();
      }

      createCarousel() {
        const emblaViewport = this.querySelector('.subscribe__embla__viewport')

        // emblaViewport only on if web 995 is enabled
        if(emblaViewport) {
          this.carousel = EmblaCarousel(emblaViewport, {
            loop: true,
            dragFree: true
          })
  
          this.carousel.on('slidefocus', (embla, event) => {
            console.log(event.detail)
          })
  
          this.carousel.scrollTo(0)
        }
      }

      destroyCarousel() {
        if (this.carousel) {
          this.carousel.destroy()
          this.carousel = null
        }
      }

      setupEventListeners() {
        this.unsubscribe.push(
          subscribe('subscription-flow:state-update', (data) => {
            if (data.selectedVariant && data.selectedVariant !== this.selectedVariant) {
              this.selectedVariant = data.selectedVariant;
              this.variantDetails = data.variantDetails;
              this.updateActiveUI();
            }
          })
        );

        Utils.setupCommonSlideEventListeners(this);
      }

      setupVariantSelection() {
        this.form = this.querySelector('[data-variants-container]');
        if (!this.form) return;

        this.variants = this.form.querySelectorAll('[data-variant]');
        this.variantImages = this.querySelectorAll('.variant_image');
        this.variantText = this.querySelectorAll('.variant_text');
        this.variantTitle = this.querySelectorAll('.variant_title');

        this.setVariantPrice()

        this.form.addEventListener('change', this.updateSelectedVariant);
      }

      updateSelectedVariant() {
        this.variants.forEach((variant) => {
          const input = variant.querySelector('input');
          if (input && input.checked) {
            if(this.carousel) {
              this.carousel.scrollTo(input.dataset.slide)
            }
            this.selectedVariant = variant.dataset.variantId;
            this.variantDetails = Utils.parseJSON(variant.querySelector('[data-variant-details]').textContent);

            this.setVariantPrice()

            publish('subscription-flow:selected-variant', {
              selected_variant: this.selectedVariant,
              variant_details: this.variantDetails,
            });
          }
        });

        this.updateActiveUI();
      }

      setVariantPrice() {
        let variant
        if(this.variantDetails) {
          variant = this.variantDetails
        } else {
          const variantDiv = this.variants[0]
          const variantDetails = variantDiv.querySelector('[data-variant-details]')
          variant = Utils.parseJSON(variantDetails.textContent)
        }

        const button_price = document.querySelectorAll('.button__price')
        button_price.forEach(elem => {
          elem.innerText =
            `(${window.Shopify.formatMoney(variant.price, window.moneyFormat).replaceAll('"', '')})`
        })
      }

      updateActiveUI() {
        this.updateActiveState(this.variantImages, 'variantId');
        this.updateActiveState(this.variantText, 'variantId');
        this.updateActiveState(this.variantTitle, 'variantId');
      }

      updateActiveState(elements, dataAttribute) {
        if (!elements) return;

        elements.forEach((element) => {
          const isActive = element.dataset[dataAttribute] === this.selectedVariant;
          element.classList.toggle('tw-is-active', isActive);
        });
      }

      disconnectedCallback() {
        Utils.HeightManager.disconnect(this);

        if (this.form) {
          this.form.removeEventListener('change', this.updateSelectedVariant);
        }

        if (this.resizeHandler && typeof window !== 'undefined') {
          window.removeEventListener('resize', this.resizeHandler);
        }

        this.unsubscribe.forEach((unsub) => {
          if (typeof unsub === 'function') unsub();
        });
      }
    }
  );
}
